import { gql } from '@apollo/client';

export const CHECK_USER_PASSWORD = gql`
	mutation CheckUserCredentials($credentials: AutenticateUserDto!) {
		checkUserCredentials(credentials: $credentials)
	}
`;
